import { render } from "./InfoSideBar.vue?vue&type=template&id=072efa80&scoped=true"
import script from "./InfoSideBar.vue?vue&type=script&lang=js"
export * from "./InfoSideBar.vue?vue&type=script&lang=js"

import "./InfoSideBar.vue?vue&type=style&index=0&id=072efa80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072efa80"]])

export default __exports__